import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { filter, switchMap, take } from 'rxjs/operators';
import { AppComponent } from '../../app.component';
import { Log } from '../../util/log';
import { UserService } from 'src/app/service/user.service';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ControlUser } from 'src/app/model/controlUser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Output() public sidenavToggle = new EventEmitter();

  ownerLogoUrl: string = "assets/img/logo_pilomat.png";
  private refreshSubAlias: Subscription;
  private refreshSubStandard: Subscription;


  serverFolder: string = environment.onecontrol.serverFolder;
  currentUrl: string = "";

  currentUserEmail: string = "";

  showEnterAsAliasEmailList: string[] = ["questura1@pilomat.com"];

  showEnterOtherDevicesEmailList: string[] = ["questura@pilomat.com"];

  canViewUser: boolean = false;;
  canViewDevice: boolean = false;
  canViewExecution: boolean = false;
  canViewOperation: boolean = false;
  canViewGroup: boolean = false;
  canViewAlias: boolean = false;
  canViewRequests: boolean = false;


  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public router: Router) {

  }

  async ngOnInit() {
    this.refreshSubAlias = this.userService.refresh.subscribe(() => {
      this.checkHeaderSections();
    });

  }

  ngAfterViewInit() {
    this.currentUrl = this.router.url;
    let test_url = "https://pilomat.1control.eu/pilomat/it/#/dashboard";
    this.appComponent.setCurrentLanguage(test_url.split("/")[4]);
    this.getUserEmail();

    if (!this.isAdmin()) {
      this.getOwnerData();
    }
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  isLoggedIn(): boolean {
    return this.appComponent.isLoggedIn();
  }

  isAdmin(): boolean {
    return this.appComponent.isAdmin();
  }

  isService(): boolean {

    return this.appComponent.isService();
  }

  // isAlias(): boolean {
  //   return this.appComponent.isAlias();
  // }

  languageSelect(language: string) {
    Log.debug("selected language: " + language);
  }

  logout() {
    this.appComponent.logout();
  }

  getOwnerData() {
    // Log.debug("this.userService.meUser.uid \n\n\n");
    // Log.debug(this.userService.meUser.uid);

    // this.userService.getOwnerData(this.userService.meUser.uid).subscribe(ownerData => {
    //   this.ownerLogoUrl = ownerData.logoUrl;
    // });
  }

  getUserEmail() {
    this.userService.getFirebaseUserObs().pipe(
      filter(firebaseUser => !!firebaseUser), // Wait until a user is logged in
      switchMap(() => this.userService.getMe()), // Now call getMe() only when logged in
      take(1) // Do this only once
    ).subscribe({
      next: (user) => {
        this.currentUserEmail = user.email;
      },
      error: (err) => {
      }
    });
  }

  showEnterAsAliasButton(): boolean {
    if (this.showEnterAsAliasEmailList.includes(this.currentUserEmail)) {
      return true;
    } else {
      return false;
    }
  }

  showEnterOtherDevicesButton(): boolean {
    if (this.showEnterOtherDevicesEmailList.includes(this.currentUserEmail)) {
      return true;
    } else {
      return false;
    }
  }

  isPilomatDev(): boolean {
    if (environment.onecontrol.serverFolder == "pilomatdev") {
      return true;
    } else {
      return false;
    }
  }

  async checkHeaderSections() {

    const isAlias = await this.appComponent.isAlias();

    if (isAlias) {
      this.canViewDevice = await this.userService.checkAliasPermissions('DeviceView');
      this.canViewUser = await this.userService.checkAliasPermissions('UserView');
      this.canViewExecution = await this.userService.checkAliasPermissions('ExecutionView');
      this.canViewOperation = await this.userService.checkAliasPermissions('OperationView');
      this.canViewGroup = await this.userService.checkAliasPermissions('GroupView');
      this.canViewAlias = await this.userService.checkAliasPermissions('AliasView');
      this.canViewRequests = await this.userService.checkAliasPermissions('accept-requests');

    } else {
      this.canViewUser = true;;
      this.canViewDevice = true;
      this.canViewExecution = true;
      this.canViewOperation = true;
      this.canViewGroup = true;
      this.canViewAlias = true;
      this.canViewRequests = true;

    }
    this.cdRef.detectChanges();
  }
}
